interface HoverTimeIndicatorProps {
  readonly hoverY: number;
  readonly hoverTime: string;
  readonly elevated?: boolean;
}

export function HoverTimeIndicator({
  hoverY,
  hoverTime,
  elevated,
}: HoverTimeIndicatorProps) {
  return (
    <div
      className={`pointer-events-none absolute left-0 right-0 ${elevated ? "z-[60]" : "z-10"}`}
      style={{ top: `${hoverY}px` }}
    >
      <div className="absolute inset-x-0 top-0 border-t border-dashed border-accent/50" />
      <span className="absolute -top-3 left-1 rounded bg-accent/90 px-1 py-0.5 text-[10px] leading-none font-medium text-accent-foreground">
        {hoverTime}
      </span>
    </div>
  );
}
